import React from 'react';
import { ReactComponent as BillingInfoIcon } from 'assets/icons/others/billing-info-large.svg';
import defaultLocales from 'globals/locales/default';
import FsBillingInfoForm from 'ui-elements/forms/FsBillingInfoForm';
import FsCenterBox from 'ui-elements/common-elements/FsCenterBox/FsCenterBox';
import FsTooltip from 'ui-elements/tooltips/FsTooltip';
import FsQuestionMarkContainedIcon from 'ui-elements/icons/FsQuestionMarkContained';
import { BillingInfoFormProps } from 'ui-elements/forms/FsBillingInfoForm/FsBillingInfoForm';
import { Headline, HeadlineWrapper } from './BillingInfo.style-elements';

interface BillingInfoProps {
  onChange: (isValid: boolean, formData?: BillingInfoFormProps) => void;
}

const BillingInfo: React.FC<BillingInfoProps> = ({ onChange }) => {
  return (
    <>
      <HeadlineWrapper>
        <FsCenterBox>
          <BillingInfoIcon />
          <Headline>{defaultLocales.billingInfo}</Headline>
        </FsCenterBox>
        <FsTooltip title={defaultLocales.billingInfoTooltipInfo}>
          <FsQuestionMarkContainedIcon />
        </FsTooltip>
      </HeadlineWrapper>
      <FsBillingInfoForm showButtons={false} onChange={onChange} />
    </>
  );
};

export default BillingInfo;
